import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Card,
  CardBody,
  CardHeader,
  Form,
  Input,
  Button,
  Row,
  Col,
  UncontrolledTooltip
} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from 'react-router-dom';
import { translate } from "react-translate";
import { 
  actionUpdateKitStatus,
  actionGetKitTypes, 
  actionSetEditKit,
  actionGetKit
} from 'store/actions/kitsActions';
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { toast } from 'react-toastify';

const PatientKitDetails = (props) => {
  const dispatch = useDispatch();
  const { t } = props;
  const { id } = useParams();
  const history = useHistory();

  const { kitEdit } = useSelector(state => state.kitsReducer);
  const kitTypes = useSelector(state => state.kitsReducer.types);
  const [address, setAddress] = useState({});

  const { register, handleSubmit } = useForm();

  useEffect(() => {
    if (!Object.keys(kitEdit).length && id) {
      dispatch(actionGetKit(id));
    }

    if (!Object.keys(kitTypes).length) {
      dispatch(actionGetKitTypes());
    }

    return () => {
      dispatch(actionSetEditKit({}));
    }
  }, []);

  useEffect(() => {
    if (Object.keys(kitEdit).length) {
      try {
        setAddress(JSON.parse(kitEdit.delivery_info.delivery_address));
      } catch (e) {
        setAddress({});
      }
    }
  }, [kitEdit]);

  const onSubmit = (data) => {
    dispatch(actionUpdateKitStatus(kitEdit._id, data.status));
  };

  const copyIdToClipboard = (e, kitId) => {
    e.preventDefault();
    navigator.clipboard.writeText(kitId);
    toast.success(t("id-copied"));
  };

  return (
    <div className="content user-manual-edit mt-3">

      {!Object.keys(kitEdit).length ? (<LoadingLocal/>) : (
        <Card>
          <CardHeader><h6>{Object.keys(kitEdit).length ? `Editing kit ${kitEdit.friendly_id}` : "New kit"}</h6></CardHeader>
          <CardBody className="big-form">

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Form id="kit-form" onSubmit={handleSubmit(onSubmit)}>
                      <div className="d-flex justify-content-between">
                        <h6>{t("kit-info")}</h6>

                        {kitEdit.status === "k_st_assigned_to_patient" ? (
                          <Button
                            size="sm"
                            color="info"
                            type="submit"
                            form="kit-form"
                          >
                            {t("update-btn")}
                          </Button>
                        ) : <></>}
                      </div>
                      

                      <div className="mb-1"><span style={{fontWeight: "bold"}}>Kit ID: </span> {kitEdit.friendly_id}
                        <div
                          className="copy-icon ml-2"
                          onClick={(e) => copyIdToClipboard(e, kitEdit.friendly_id)}
                          id={`tooltip-detail-1`}
                        >
                          <i className="now-ui-icons files_single-copy-04"></i>
                        </div>

                        <UncontrolledTooltip placement="top" target={`tooltip-detail-1`}>
                            {kitEdit.friendly_id}
                        </UncontrolledTooltip>
                      </div>

                      <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("type")}: </span> <span>{kitEdit.type}</span></div>

                      <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("practice")}: </span> <span>{kitEdit.delivery_info.practice.name}</span>
                        <small className="practice-owner-field">({kitEdit.delivery_info.practice.owner.firstName} {kitEdit.delivery_info.practice.owner.lastName} {kitEdit.delivery_info.practice.owner.auth_user_id})</small>
                      </div>

                      <div className="d-flex mt-3 mb-2">
                        <div className="mr-3" style={{fontWeight: "bold"}}>{t("status")}:</div> 
                        <div>

                          {kitEdit.status === "k_st_assigned_to_patient" ? (
                            <Input 
                              className={""}
                              type="select" 
                              name="status" 
                              id="status"
                              innerRef={register}
                            >
                            <option value={"k_st_in-production"}>{t("k_st_in-production")}</option>
                            <option value={"k_st_deleted"}>{t("k_st_deleted")}</option>
                          </Input>
                          ) : (
                            <p>{t(kitEdit.status)}</p>
                          )}

                        </div>
                      </div>
                    
                      <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("created")}: </span> <span>{moment(kitEdit.created_at).format("YYYY-MM-DD HH:mm:ss SSS")}</span></div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>

              <Col>
                <Card>
                  <CardBody>
                    <h6>{t("patient-info")}</h6>

                    <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("full-name")}</span>: <span>{`${kitEdit.delivery_info.patient.firstName} ${kitEdit.delivery_info.patient.lastName}`}</span></div>
                    <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("tp-id")}</span>: <span>{kitEdit.delivery_info.patient_auth_user_id}</span></div>
                    <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("ext-ref")}</span>: <span>{kitEdit.delivery_info.patient.ext_ref}</span></div>
                    <div className="mb-1"><span style={{fontWeight: "bold"}}>{t("phone-number")}</span>: <span>{kitEdit.delivery_info.patient.phone}</span></div>

                    <div className="mt-3">
                      <span style={{fontWeight: "bold"}}>{t("delivery-address")}</span>: <span>{Object.keys(address).length ? Object.keys(address).map((ad,i) => {
                        return (
                            <div 
                              key={`ad-${i}`} 
                            >
                              <span style={{textTransform: "capitalize", fontWeight: "bold"}}>{ad}</span>: <span>{address[ad]}</span>
                            </div>
                          )
                      }) : ""}</span>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>


            <Row>
              
              <Col>

                <Card>
                  <CardBody>
                    <h6>{t("reserved-assets")}</h6>

                    <div className="log-fixed-height">
                      {kitEdit.assets.map(as => {
                        return (
                          <div 
                            key={`as-${as._id}`} 
                            className="assigned-kit"
                            style={{width: "fit-content"}}
                          >
                            <div>ID: <span>{as._id}</span></div>
                            <div>Type: <span>{as.asset_type}</span></div>
                            <div>Serial: <span>{as.serial_number}</span></div>
                            <div>Brand: <span>{as.brand}</span></div>
                          </div>
                        )
                      })}
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col>
                <Card>
                  <CardBody>
                    <h6>{t("kit-tracking-info")}</h6>

                    <div className="log-fixed-height">
                        {kitEdit.statesTracking.map(st => {
                          const log = JSON.parse(st.log);
                          return (
                            <div 
                              key={`st-${st._id}`} 
                              className="log-container"
                            >
                              <div><span style={{textTransform: "capitalize", fontWeight: "bold"}}>Date</span>: <span>{moment(st.date).format("YYYY-MM-DD HH:mm:ss SSS")}</span></div>
                              {Object.keys(log).map(l => 
                                <div>
                                  <span style={{textTransform: "capitalize", fontWeight: "bold"}}>{l}</span>: <span>{log[l]}</span>
                                </div>
                              )}
                            </div>
                          )
                        })}
                    </div>
                  </CardBody>
                </Card>
                
              </Col>

            </Row>

            <Button
              size="sm"
              color="danger"
              type="reset"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();
              }}
            >
              {t("return-btn")}
            </Button>
          </CardBody>
        </Card>
      )}

      
    </div>
  );
};

export default translate("kits")(PatientKitDetails);
